<main id="maincontent" role="main">
  <section class="rs-es-first-section">
    <div class="row">
      <div class="columns small-12">
        <div class="small-only-text-center">
          <div
            class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>

        <div class="rs-panel-big rs-bg-c2 clearfix">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>

          <div class="row">
            <div class="columns small-12 medium-8">
              <div
                class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
          <div class="rs-flex-row">
            <div class="rs-flex-columns small-12">
              <div class="rs-slider rs-slider-s rs-padding-bottom2">
                <ul class="rs-slides">
                  <li class="rs-slide small-12 medium-6">
                    <div
                      class="panel rs-maxw rs-h-s29 rs-h-m50 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading rs-no-radius-bottom-m"
                    ></div>
                    <div
                      class="panel rs-maxw rs-h-m21 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading rs-no-radius-top-m"
                    ></div>
                  </li>
                  <li class="rs-slide small-12 medium-6">
                    <div
                      class="panel rs-maxw rs-h-s29 rs-h-m50 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading rs-no-radius-bottom-m"
                    ></div>
                    <div
                      class="panel rs-maxw rs-h-m21 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading rs-no-radius-top-m"
                    ></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-le2"></div>
      </div>
    </div>
  </section>
</main>
